module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("To my grandparents, Nathan and Ida")])]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("And to the workers")])]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“I don’t know how it came to me, so much common sense.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("—Nathan Handwerker")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0